import React from "react";
import { Card, CardBody } from "@windmill/react-ui";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from 'react-i18next';

import {
  FiCodepen,
  FiFile,
  FiBookOpen,
  FiUsers,
  FiArchive,
  FiAperture,
  FiCompass,
  FiSlack,
  FiPackage,
} from 'react-icons/fi';

const icons = {
  'FiUsers': <FiUsers />,
  'FiFile': <FiFile />,
  'FiCodepen': <FiCodepen />,
  'FiArchive':<FiArchive />,
  'FiBookOpen':<FiBookOpen />, 
  'FiAperture':<FiAperture />,
  'FiSlack':<FiSlack />,
  'FiCompass':<FiCompass />,
  'FiPackage':<FiPackage />
};


const CardItem = ({
  title,
  icon,
  price,
  amount,
  className,
  loading,
  mode,
  cash,
  card,
  credit,
  pending,
  todayPending,
  olderPending,
}) => {
const { t } = useTranslation();
  return (
    <>
      {loading ? (
        <Skeleton
          count={2}
          height={40}
          className="dark:bg-gray-800 bg-gray-200"
          baseColor={`${mode === "dark" ? "#010101" : "#f9f9f9"}`}
          highlightColor={`${mode === "dark" ? "#1a1c23" : "#f8f8f8"} `}
        />
      ) : (
        <Card className="flex h-full">
          <CardBody className="flex items-center border border-gray-200 dark:border-gray-800 w-full rounded-lg">
            <div
              className={`flex items-center justify-center p-3 rounded-full w-12 text-center mr-4 text-lg ${className}`}
            >
           {icons[icon]} 
            </div>

            <div>
              <h6 className="text-sm mb-1 font-medium text-gray-600 dark:text-gray-400">
                <span>{title}</span>{" "}
               
              </h6>
             

              <p className="text-2xl font-bold leading-none text-gray-600 dark:text-gray-200">
                {cash}
              </p>
              <div className="flex text-center items-center justify-center  text-xs font-normal text-gray-600 dark:text-gray-200">
                
                    <div className="px-1 mt-3">
                      {t("Completed")} :
                      {card}
                    </div>
                    <div className="px-1 mt-3">
                      {t("Canceled")} :
                      {credit}
                    </div>
                  </div>
            </div>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default CardItem;
